export default {
  noData: 'No data to compare.',
};
